import { useContext } from "react";
import { observer } from "mobx-react-lite";
import styled from "styled-components";
import { Callout } from "@blueprintjs/core";

import { WorkbenchContext } from "@pages/editor/providers";
import { SearchPatternComponent } from "@pages/editor/types";

import { FixRow } from "./FixRow";
import { LanguageSelectRow } from "./LanguageSelectRow";
import { PatternRow } from "./PatternRow";

const Grid = styled.div`
  display: grid;
  // label input +button -button
  grid-template-columns: max-content auto max-content max-content;
  gap: 16px;
  padding: 28px;
  max-width: 100%;
`;

const SimpleModeComponent = () => {
  const { workbench } = useContext(WorkbenchContext);
  const { bundle } = workbench;

  if (bundle?.simpleRule === undefined) {
    return (
      <div style={{ padding: "16px" }}>
        <Callout intent="danger">
          Your rule can't be converted to simple mode because it's either
          invalid or too complex. Check that the rule is valid or start a new
          rule from scratch!
        </Callout>
      </div>
    );
  }

  return (
    <Grid>
      <LanguageSelectRow />
      {bundle.simpleRule.patterns.map((pattern, idx) => (
        <PatternRow
          patternComponent={pattern as SearchPatternComponent}
          key={idx}
          index={idx}
        />
      ))}
      {bundle.simpleRule.fix !== "" && <FixRow />}
    </Grid>
  );
};

export const SimpleMode = observer(SimpleModeComponent);
